<template>
  <div>
    <v-dialog v-model="show" persistent max-width="70%">
      <v-card>
        <v-app-bar dark text color="secondary">
          <v-toolbar-title class="subheading">{{ $t("enrolments.title") }}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('enrolments.search')"
                    v-model="search_params.any"
                    @keydown="checkKeyPress"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="py-0 mt-4">
          <v-data-table
            :headers="headers"
            :items="enrolments"
            :items-per-page="enrolments.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            item-key="id"
            :show-select="true"
            v-model="selected"
            :must-sort="true"
          >
            <template v-slot:item.enrolment_organisation_id="{ item }">
              {{ item.enrolment_organisation_id ? item.organisation.name : "" }}
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <action-button type="cancel" @click="cancel" small />
          <action-button type="save" @click="submit" small />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "EnrolmentListPopup",

  props: {
    show: {
      type: Boolean,
      required: true
    },
    except_ids: {
      type: Array
    },
    statuses: {
      type: Array
    },
    coursetype_id: {
      type: Number
    }
  },

  data() {
    return {
      url: "",
      selected: [],
      enrolments: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["first_name"],
        sortDesc: []
      },
      search_params: {
        not_in_ids: "",
        coursetype_id: "",
        statuses: "",
        title: "",
        any: ""
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("enrolments.p_first_name"), value: "first_name" },
          { text: this.$t("enrolments.p_last_name"), value: "last_name" },
          { text: this.$t("enrolments.p_email"), value: "email" },
          { text: this.$t("enrolments.p_mobile"), value: "mobile" },
          { text: this.$t("enrolments.p_company"), value: "enrolment_organisation_id" }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh && this.show) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.refresh = true
      }
    },
    show: {
      handler(val) {
        if (val) {
          this.selected = []
          this.enrolments = []
          this.list()
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "enrolments"
  },

  methods: {
    list() {
      this.show_loading = true
      this.search_params.not_in_ids = this.except_ids ? this.except_ids.join(",") : null
      this.search_params.statuses = this.statuses ? this.statuses.join(",") : null
      this.search_params.coursetype_id = this.coursetype_id

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.enrolments = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    filter(target) {
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.refresh = true
    },

    cancel() {
      this.$emit("callback_enrlistpopup_cancel")
    },

    submit() {
      this.$emit("callback_enrlistpopup_submit", this.selected)
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
